module.exports = __webpack_public_path__ + "static/media/Credits-35.74550e57.pdf";